module.exports = "/images/eoi-img--bg.png?6151817dbf4e85114c641a64fbe4aaa4";